export * from './UsuarioServiceAdapter'